import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#0a0a0a' }}>
      {/* Header */}
      <nav className="px-6 lg:px-12 py-6 border-b border-white/10">
        <div className="flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2">
            <img src="/revocut-logo.png" alt="RevoCut" className="w-10 h-10" />
            <span className="text-xl font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>REVOCUT</span>
          </button>
          <button 
            onClick={() => navigate(-1)}
            className="text-sm text-gray-400 hover:text-white transition-colors flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="py-12 px-6 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Impressum
          </h1>

          <div className="space-y-8">
            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Angaben gemäß § 5 TMG
              </h2>
              <div className="text-gray-400 space-y-1">
                <p>RevoCut Media</p>
                <p>[Adresse hier einfügen]</p>
                <p>[PLZ Stadt]</p>
              </div>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Kontakt
              </h2>
              <p className="text-gray-400">
                E-Mail:{' '}
                <a href="mailto:info@revocut-media.de" className="hover:text-white transition-colors" style={{ color: '#5C63FF' }}>
                  info@revocut-media.de
                </a>
              </p>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <div className="text-gray-400 space-y-1">
                <p>[Name hier einfügen]</p>
                <p>[Adresse hier einfügen]</p>
              </div>
            </section>

            <section 
              className="p-8 rounded-2xl border border-white/10"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
            >
              <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Haftungsausschluss
              </h2>
              
              <h3 className="font-semibold text-white mb-2">Haftung für Inhalte</h3>
              <p className="text-gray-400 mb-4">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              </p>
              
              <h3 className="font-semibold text-white mb-2">Haftung für Links</h3>
              <p className="text-gray-400">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Impressum;
